import {ArrowUpRight} from '@nlabs/gothamjs/icons';
import {ArticleLink} from './ArticleLink';
import {ArticleImage} from './ArticleImage';
import type {Article} from '../types/article';

interface StoryCardProps {
  article: Article;
  compact?: boolean;
}

export const StoryCard = ({article, compact = false}: StoryCardProps) => {
  const isExternal = article.sourceType === 'external';
  return (
    <article className={`story-card${compact ? ' story-card--compact' : ''}`}>
      {article.image ? (
        <ArticleLink article={article} className="story-card__image-link">
          <ArticleImage className="story-card__image" image={article.image} />
        </ArticleLink>
      ) : null}
      <div className="story-card__content">
        <span className="story-card__section">{article.section}</span>
        <h3><ArticleLink article={article}>{article.headline}</ArticleLink></h3>
        {!compact && <p>{article.description}</p>}
        <div className="story-card__source">
          <span>{article.sourceName}</span>
          {isExternal && <ArrowUpRight aria-label="Opens publisher site" size={13} strokeWidth={1.8} />}
        </div>
      </div>
    </article>
  );
};
